import React from "react";

import DashboardLayout from "./DashboardLayout";

const Dashboard = () => {
  return (
    <DashboardLayout>
      <div>Dashboard</div>
    </DashboardLayout>
  );
};

export default Dashboard;
